const BACK_END = "https://wallet-project-goit-back.herokuapp.com";

// const BACK_END = "http://localhost:3001";

export { BACK_END };
